import useSWR from "swr";
import { mapRawToPcmVersion } from "@/mappers/pcmVersion";
import { RawPcmVersion } from "@/types/pcmVersion";
import { SWRApiError, swrConfigOptions, useFetcher } from "./swr";

export const usePcmVersions = () => {
  const fetcher = useFetcher();

  const { data = [], ...rest } = useSWR<RawPcmVersion[], SWRApiError>(
    { url: "/pcm_versions" },
    fetcher,
    swrConfigOptions,
  );

  return { data: data.map(mapRawToPcmVersion), ...rest };
};
